import React from 'react'
import CopyButton from '@components/demo/CopyButton'

import {t} from '@lib/helpers'

const UploadResult = ({result}) => {
  return (
    <div className='DemoDetail__upload__api'>
      <header>
        <h6>{t('pages.demo.shared.upload_form.api')}</h6>

        <CopyButton text={result} />
      </header>

      <pre>{result}</pre>
    </div>
  )
}

export default UploadResult
